// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4577) return "static/chunks/2b7b2d2a-31c0ca61c32987bd.js";
	if (chunkId === 2539) return "static/chunks/2539-348902620282868c.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"804":"cbe9d806b4b3ffe6","895":"1d26a7b754853291","2126":"0e2a0505716c9149","2754":"2e9cf64861582e56","3902":"01f7f3b642e515f4","5279":"1f180bb5470e0794","7229":"ef905d2196dd9daa","8701":"7d2055e4c90fef66"}[chunkId] + ".js";
};